<template>
  <div class="text-left mx-3">
    <div class="row">
      <div class="col-sm-auto">
        <h3 class="h3 font-weight-bolder my-2">Crew Incident / Behavior</h3>
      </div>
      <div class="col-sm-auto">
        <template v-if="(crew.active == 1 || isSystemAdmin) && (isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest && !isKline">
          <AddCrewBehaviour></AddCrewBehaviour>
        </template>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 text-small text-center">
        <table class="table table-hover table-bordered table-sm">
          <thead class="bg-lightgray">
          <tr>
            <th width="1%">#</th>
            <th width="8%">Behavior Type</th>
            <th>Vessel</th>
            <th>Port From</th>
            <th>Port To</th>
            <th width="7%">Date</th>
            <th>Manning</th>
            <th width="30%">Remarks</th>
            <th style="width: 2%;">VDR Codes</th>
            <th width="1%">File</th>
            <th>Action</th>
          </tr>
          </thead>
          <tbody>

          <tr v-if="isLoading">
            <td colspan="100%">
              <app-loading></app-loading>
            </td>
          </tr>

          <template v-else>
            <tr v-for="(crewIncident, index) in crewIncidents" :key="crewIncident.id">
              <td>{{ index + 1 }}</td>
              <td :title="crewIncident.incidentType">{{ crewIncident.incidentCode }}</td>
              <td>{{ crewIncident.vessel }}</td>
              <td>{{ crewIncident.port }}</td>
              <td>{{ crewIncident.toPort }}</td>
              <td>{{ crewIncident.incident_date | moment('DD MMM YYYY') }}</td>
              <td>{{ crewIncident.manning }}</td>
              <td style="white-space: pre-wrap">{{ crewIncident.remarks }}</td>
              <td class="font-weight-bolder" v-if="crewIncident.vdrObservations">
                {{ generateListNum(crewIncident.vdrObservations) }}
              </td>
              <td v-else>{{}}</td>
              <td>{{ crewIncident.crewIncidentAttachments.length }}</td>
              <td>
                <button class="btn btn-outline-info btn-xs mr-1"
                        data-toggle="modal" data-target="#view-crew-behaviour"
                        @click="updateCrewIncidentModal(crewIncident)"
                >
                  <i class="fas fa-eye"></i>
                  View
                </button>
                <template v-if="(crew.active == 1 || isSystemAdmin) && (isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !isKline">
                  <button class="btn btn-outline-danger btn-xs"
                          @click="confirmDeleteCrewIncident(crewIncident.id)"
                  >
                    <i class="fas fa-trash"></i>
                    Delete
                  </button>
                </template>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>

    <view-crew-behaviour :view-crew-behaviour="crewIncident"/>

  </div>
</template>

<script>

import {vueAppMixin} from "@/mixins/vueAppMixin";
import {mapActions, mapGetters} from 'vuex';
import {gateMixin} from "@/mixins/gateMixin";

import AddCrewBehaviour
  from "@/components/sub_components/master_lists/crews/crew_show_components/crew_behavior/AddCrewBehaviour";
import AppLoading from "@/components/elements/AppLoading";
import ViewCrewBehaviour
  from "@/components/sub_components/master_lists/crews/crew_show_components/crew_behavior/ViewCrewBehaviour";

export default {
  name: "CrewBehavior",
  mixins: [vueAppMixin, gateMixin],
  components: {
    AddCrewBehaviour,
    AppLoading,
    ViewCrewBehaviour
  },

  data() {
    return {
      crewIncident: {},
      crewIncidentErrors: {},
      atSea: false,
      editable: false,
      tempCrewIncident: {},
      incidentAttachment: {},
      originalIncidentAttachment: {},
      crewIncidentAttachmentFile: '',
      attachmentIndex: null,
      newIncidentAttachment: {}
    }
  },

  methods: {
    ...mapActions([
      'getIncidentKeys',
      'getVesselKeys',
      'getPortKeys',
      'getManningKeys',
      'getVdrObservationKeys',
      'getCrewIncidents',
      'updateCrewIncident',
      'getIncidentAttachmentFile',
      'updateCrewIncidentAttachment',
      'deleteIncidentAttachment',
      'addCrewIncidentAttachment',
      'deleteCrewIncident',
      'getOtherVesselKeys'
    ]),

    async initializeData() {
      await this.getCrewIncidents({crewId: this.crew.id});
      await this.getIncidentKeys();
      if (this.isOchg && !this.isSystemAdmin) {
        let vesselParams = {
          manningId: this.crew.manning_id
        };
        this.getVesselKeys(vesselParams);
      } else {
        this.getVesselKeys();
      }
      await this.getPortKeys();
      await this.getManningKeys();
      await this.getVdrObservationKeys();
    },

    updateCrewIncidentModal(crewIncident) {
      this.crewIncident = Object.assign({}, crewIncident);
      this.atSea = !!this.crewIncident.to_port_id;
    },

    async confirmUpdateCrewIncident() {
      if (this.editable) {
        if (await this.confirmUpdate()) {
          let params = {
            crewIncidentId: this.crewIncident.id,
            manning_id: this.crewIncident.manning_id,
            incident_date: this.crewIncident.incident_date,
            incident_id: this.crewIncident.incident_id,
            vessel_id: this.crewIncident.vessel_id,
            port_id: this.crewIncident.port_id,
            to_port_id: this.crewIncident.to_port_id,
            remarks: this.crewIncident.remarks,
            viewable: this.crewIncident.viewable,
          };

          let updatedCrewIncident = await this.updateCrewIncident(params);
          if (updatedCrewIncident.errors) {
            this.crewIncidentErrors = updatedCrewIncident.errors;
          } else {
            this.successAlert('Crew Incident Successfully Updated', 'UPDATE');
            document.getElementById('close-crew-incident').click();
            this.editable = false;
          }

        }
      } else {
        this.editable = true;
        this.tempCrewIncident = Object.assign({}, this.crewIncident);
        this.activateButtonElements(false);
      }
    },

    cancelCrewIncidentEdit() {
      this.crewIncident = Object.assign({}, this.tempCrewIncident);
      this.editable = false;
      this.activateButtonElements(true);
    },

    async confirmUpdateIncidentAttachment(crewIncidentAttachment) {
      if (this.incidentAttachment.id === crewIncidentAttachment.id) {
        if (await this.confirmUpdate()) {
          let formData = new FormData();
          formData.append('crewIncidentAttachmentId', crewIncidentAttachment.id);
          formData.append('description', crewIncidentAttachment.description);

          let input = document.getElementById('incident-attachment-' + crewIncidentAttachment.id)
          if (input.files && input.files[0]) {
            let file = input.files[0];
            formData.append('incidentAttachment', file);
          }
          let updatedCrewIncidentAttachment = await this.updateCrewIncidentAttachment(formData);

          if (!updatedCrewIncidentAttachment.errors) {
            this.successAlert('Crew Incident Attachment Successfully Updated', 'UPDATE');
            this.incidentAttachment = {};
            this.originalIncidentAttachment = {};
          }
        }
      } else {
        this.activateButtonElements(false);
        document.getElementById('edit-attachment-' + crewIncidentAttachment.id).disabled = false;
        document.getElementById('edit-crew-incident').disabled = true;
        this.incidentAttachment = crewIncidentAttachment;
        this.originalIncidentAttachment = Object.assign({}, crewIncidentAttachment);

      }
    },

    cancelEditAttachment() {
      this.activateButtonElements(true);
      document.getElementById('edit-crew-incident').disabled = false;
      this.undoEditCrewIncidentAttachment();
      this.incidentAttachment = {};
    },

    undoEditCrewIncidentAttachment() {
      let index = this.crewIncident.crewIncidentAttachments.findIndex(crewIncidentAttachment => {
        return crewIncidentAttachment.id === this.incidentAttachment.id;
      });
      this.crewIncident.crewIncidentAttachments.splice(index, 1, this.originalIncidentAttachment);
    },

    async loadIncidentAttachmentFile(crewIncidentAttachmentId, attachmentIndex) {
      this.crewIncidentAttachmentFile = '';
      let params = {
        incidentAttachmentId: crewIncidentAttachmentId
      }
      let crewIncidentAttachmentFile = await this.getIncidentAttachmentFile(params);
      if (crewIncidentAttachmentFile) {
        this.crewIncidentAttachmentFile = crewIncidentAttachmentFile ? `data:application/pdf;base64,${crewIncidentAttachmentFile}` : '';
      }
      this.attachmentIndex = attachmentIndex;
    },

    activateButtonElements(active) {
      document.getElementsByName('edit-attachment').forEach(editAttachmentButton => {
        editAttachmentButton.disabled = !active;
      });
      document.getElementsByName('delete-attachment').forEach(editAttachmentButton => {
        editAttachmentButton.disabled = !active;
      });
    },

    async confirmDeleteIncidentAttachment(incidentAttachment) {
      if (await this.confirmUpdate()) {
        let params = {
          incidentAttachmentId: incidentAttachment.id,
          crew_incident_id: incidentAttachment.crew_incident_id
        };
        let deletedIncidentAttachment = await this.deleteIncidentAttachment(params);
        if (deletedIncidentAttachment) {
          this.successAlert('Crew Incident Attachment Successfully Deleted', 'DELETE');
        } else {
          this.errorAlert('Crew Incident Attachment Failed to Delete', 'DELETE');
        }
      }
    },

    async confirmSaveNewIncidentAttachment() {
      if (await this.confirmCreateAlert('Are you sure you want to add this new attachment?')) {
        let formData = new FormData();
        formData.append('crew_incident_id', this.crewIncident.id);
        if (this.newIncidentAttachment.description) {
          formData.append('description', this.newIncidentAttachment.description);
        }
        let input = document.getElementById('incident-attachment-new');
        if (input.files && input.files[0]) {
          let file = input.files[0];
          formData.append('incidentAttachment', file);
        }
        let newIncidentAttachment = await this.addCrewIncidentAttachment(formData);
        if (newIncidentAttachment) {
          this.successAlert('Crew Incident Attachment Successfully Added', 'CREATE');
          this.newIncidentAttachment = {};
        } else {
          this.errorAlert('Crew Incident Attachment Failed to Save', 'CREATE');
        }
      }
    },

    async confirmDeleteCrewIncident(crewIncidentId) {
      if (await this.confirmDeleteAlert()) {
        let deletedCrewIncident = await this.deleteCrewIncident({incidentId: crewIncidentId});
        if (deletedCrewIncident) {
          this.successAlert('Crew Incident Successfully Deleted', 'DELETE');
        } else {
          this.errorAlert('Crew Incident Attachment Failed to Delete', 'DELETE');
        }
      }
    },

    updateFileLabel(labelIdentifier) {
      let fileInput = document.getElementById('incident-attachment-' + labelIdentifier);
      let labelId = 'incident-attachment-label-' + labelIdentifier;
      let fileLabel = document.getElementById(labelId);
      let labelText = 'Choose File';
      if (fileInput.files && fileInput.files[0]) {
        let file = fileInput.files[0];
        labelText = file.name;
      }
      fileLabel.innerHTML = labelText;
    },

    generateListNum(listCode) {
      return _.chunk(listCode.slice().sort((a, b) => {
        return a - b
      }), 10).join("\n")
    }

  },

  computed: {
    ...mapGetters([
      'crewIncidents',
      'incidentKeys',
      'vesselKeys',
      'portKeys',
      'manningKeys',
      'crew'
    ])
  },

  created() {
    this.initializeData();
  }


}
</script>

<style scoped>
.bg-lightgray {
  background: lightgray;
}

.scale-1-half {
  transform: scale(1.5);
}
</style>